<template lang="html">

  <section class="logout">
    <h1>Log Out</h1>
    <div class="user-note">
      <p>You must complete all areas to finish your inspection. You may logout and return to complete your inspection any time within the move-in window. Any rooms that you have submitted will remain completed. Any information for rooms that you have not yet submitted will not be saved. </p>
    </div>
    <button v-on:click="logout">Log Out</button>

  </section>

</template>

<script lang="js">

  import router from '@/router.js';

  export default  {
    name: 'logout',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
      logout(){
        this.$store.dispatch('logOut');
        router.push('/');
      }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .logout {

  }
</style>
